import { render, staticRenderFns } from "./error-icon.vue?vue&type=template&id=61cab654&"
import script from "./error-icon.vue?vue&type=script&lang=js&"
export * from "./error-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports